import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=fef0649e&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=fef0649e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports